import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

export function LabelText({ children }: Props) {
  return <div className="contents leading-tight">{children}</div>;
}
